import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import "react-datepicker/dist/react-datepicker.css";
import "../catalog.scss";
import CheckoutBlank from '../../checkout/checkoutBlank';
import CheckoutSell from '../../checkout/checkoutSell';
import CheckoutPayment from '../../checkout/checkoutPayment';
import { _Api } from "../../common/api/_call";
import { useSelector } from 'react-redux';
import Itemlist from "../Itemlist";
import CatalogNavbar from '../CatalogNavbar';
import { useTranslation } from 'react-i18next';
import newCatalogSearchIcon from '../../../assets/images/newcatalogsearchicon.svg';
import newCatalogSearchClearIcon from '../../../assets/images/newcatalogsearchclearicon.svg';

const CollectionList = () => {
  const { t } = useTranslation();
  const [isCrown, setCrown] = useState(true);
  const customer = useSelector((state) => state.app.customer);
  const { state } = useLocation();
  const navigate = useNavigate();
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const [Navid, setNavid] = useState();
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const searchInputRef = useRef(null);
  const [showcheckout, setShowcheckout] = useState(localStorage.getItem('showcheckout') || 'blank');
  const [, setdeletestatus] = useState(false);
  const [showpayment, setShowpayment] = useState(false);
  const [UpdatedCart, setUpdatedCart] = useState();
  const checksale = localStorage.getItem('showcheckout') === "sell";
  const [searchproductstatus, setsearchproductstatus] = useState(checksale || false);
  const [searchlist, setSearchlist] = useState([]);
  const [Optiondetails, setOptiondetails] = useState(true);
  const resolvedNavId = Navid ?? state?.navids;
  const searchDebounceRef = useRef(null);
  const crownClick = () => {
    setCrown((current) => !current);
    setOptiondetails((current) => !current);
  };

  useEffect(() => {
    if (state?.filtertype) {
      setCrown(state?.filtertype);
      setOptiondetails(state?.filtertype);
    }
    if (state?.parkid || state?.order_id) {
      GetCartdetailpark();
    }
    // eslint-disable-next-line
  }, [state?.filtertype, state?.parkid, state?.order_id]);

  const GetCartdetailpark = async () => {
    try {
      const postdata = {
        park_id: state?.parkid,
        order_id: state?.order_id,
        order_edit: state?.order_edit,
        order_type: state?.order_type,
      };
      const res = await _Api(postdata, `api/v1/POS/customOrder/getCartItems`);
      if (res.code === 200) {
        setUpdatedCart(res?.data);
        setShowcheckout('sell');
      } else {
        navigate('/app/pos/menu');
      }
    } catch (err) {
      console.log(err, 'err');
    }
  };

  const getsearchcatalog = async (search) => {
    try {
      const postdata = {
        type: Optiondetails === true ? 'catalog' : 'inventory',
        limit: 0,
        skip: 0,
        sale: "top_sale",
        search: search ? search : "",
        customer_id: customer?.id,
        category_id: resolvedNavId || "",
      };
      const res = await _Api(postdata, `api/v1/POS/home/search`);
      if (res.code === 200) {
        setSearchlist(res?.data);
      } else {
        setSearchlist([]);
      }
    } catch (err) {
      console.log(err, 'err');
    }
  };

  useEffect(() => {
    if (searchQuery) {
      getsearchcatalog(searchQuery);
    } else {
      setSearchlist([]);
    }
    // eslint-disable-next-line
  }, [Optiondetails]);
  useEffect(() => {
    return () => {
        if (searchDebounceRef.current) {
            clearTimeout(searchDebounceRef.current);
        }
    };
}, []);
  useEffect(() => {
    if (searchOpen && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [searchOpen]);
  // const handleSearchChange = (value) => {
  //   setSearchQuery(value);
  //   if (value?.trim()) {
  //     getsearchcatalog(value);
  //   } else {
  //     setSearchlist([]);
  //   }
  // };


  const handleSearchChange = (value) => {
    setSearchQuery(value);
    if (searchDebounceRef.current) {
        clearTimeout(searchDebounceRef.current);
    }
    if (!value.trim()) {
      setSearchlist([]);
      return;
    }
    searchDebounceRef.current = setTimeout(() => {
      getsearchcatalog(value);
    }, 300);
  };

  const closeSearch = () => {
    setSearchOpen(false);
    setSearchQuery('');
    setSearchlist([]);
  };

  const renderSearchDropdown = () =>
    searchlist?.length ? (
      <ul className="dropdown-menu custom-search-dropdown catalog-all-search-dropdown show">
        {searchlist.map((result, key) => (
          <Link
            to="/app/pos/products/ProductDetails"
            className="link-style"
            onClick={() =>
              setproductdata(result?._id, result?.name, result?.Item)
            }
            key={key}
          >
            <li className="dropdown-item pos-search-result-item">
              {searchResultRowContent(result)}
            </li>
          </Link>
        ))}
      </ul>
    ) : null;

  const renderSearchBar = () => (
    <div className="catalog-all-toolbar-search-wrap catalog-collection-list-search-wrap">
      <div className="com-search-area catalog-all-search-bar-input">
        <img
          className="catalog-all-search-bar-icon"
          src={newCatalogSearchIcon}
          alt=""
        />
        <input
          ref={searchInputRef}
          type="text"
          value={searchQuery}
          // onChange={(e) => handleSearchChange(e.target.value)}
          onChange={(e) => {
            const value = e.target.value;
            setSearchQuery(value);
            if (searchDebounceRef.current) {
              clearTimeout(searchDebounceRef.current);
            }
            if (!value?.trim()) {
              setSearchlist([]);
              return;
            }
            searchDebounceRef.current = setTimeout(() => {
              getsearchcatalog(value);
            }, 300);
          }}
          placeholder={t('Search SKU, Stock ID, Product name')}
          autoComplete="off"
          aria-label={t('Search SKU, Stock ID, Product name')}
        />
        <button
          type="button"
          className="catalog-all-search-bar-clear"
          onClick={closeSearch}
          aria-label={t('Close search')}
        >
          <img
            className="catalog-all-search-bar-clear-icon"
            src={newCatalogSearchClearIcon}
            alt=""
          />
        </button>
      </div>
      {renderSearchDropdown()}
    </div>
  );

  const searchResultRowContent = (result) => (
    <>
      <div className="pos-search-result-thumb">
        {result?.main_image ? (
          <img
            src={result.main_image}
            alt=""
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "https://gis247.s3.us-east-2.amazonaws.com/placeholder-blank.png";
            }}
          />
        ) : null}
      </div>
      <div className="pos-search-result-text">
        <div className="pos-search-result-name">{result?.name}</div>
        <div className="pos-search-result-meta">
          {result?.SKU}
          {result?.stock_id ? " - " + result.stock_id : ""}
        </div>
      </div>
    </>
  );

  const setproductdata = (productid, name, item) => {
    const data = {
      productid,
      filter: Optiondetails ? true : false,
      itemname: name,
      itemid: item,
      NavId: resolvedNavId,
      parkid: state?.parkid ? state?.parkid : "",
      order_id: state?.order_id ? state?.order_id : "",
      order_type: state?.order_type ? state?.order_type : "",
      order_edit: state?.order_edit ? state?.order_edit : false,
    };
    localStorage.setItem('productdata', JSON.stringify(data));
  };

  useEffect(() => {
    localStorage.setItem('showcheckout', showcheckout);
  }, [showcheckout]);

  return (
    <>
      <div className="main-body">
        <div className="main-body-row">
          <div className="main-body-row-left-col p-0">
            <div className="catalog-area">
              <div className='catalog-area-header-area'>
                <CatalogNavbar
                  setNavid={setNavid}
                  navid={Navid ?? state?.navids}
                />
                <div
                  className={
                    searchOpen
                      ? 'catalog-all-toolbar catalog-all-toolbar--search-open catalog-collection-list-toolbar'
                      : 'catalog-all-toolbar catalog-collection-list-toolbar'
                  }
                >
                  <button
                    type="button"
                    className={
                      isCrown
                        ? 'catalog-all-toolbar-left-btn is-catalog'
                        : 'catalog-all-toolbar-left-btn is-inventory'
                    }
                    onClick={crownClick}
                    aria-label={isCrown ? t('Catalog view') : t('Inventory view')}
                  >
                    <img
                      src={
                        isCrown
                          ? base_assets + 'images/pos/icons/crown-outline.png'
                          : base_assets + 'images/pos/icons/warehouse.png'
                      }
                      alt=""
                    />
                  </button>

                  {searchOpen ? (
                    renderSearchBar()
                  ) : (
                    <div className="catalog-all-toolbar-actions catalog-all-toolbar-actions--default">
                      <button
                        type="button"
                        className="catalog-all-toolbar-action"
                        onClick={() => setSearchOpen(true)}
                        aria-label={t('Search')}
                      >
                        <img
                          className="catalog-all-toolbar-icon"
                          src={newCatalogSearchIcon}
                          alt=""
                        />
                      </button>
                    </div>
                  )}
                </div>
              </div>
              <div className="tab-content catalog-area-ct">
                <div
                  className={
                    state?.navids || Navid
                      ? "h-100 tab-pane fade show active"
                      : "h-100 tab-pane fade"
                  }
                  id="jalwary"
                >
                  <Itemlist
                    NavId={resolvedNavId}
                    Optiondetails={Optiondetails}
                    parkid={state?.parkid}
                    order_id={state?.order_id}
                    order_edit={state?.order_edit}
                    order_type={state?.order_type}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="main-body-row-right-col">
            {showcheckout === 'sell' ? (
              <CheckoutSell
                setShowcheckout={setShowcheckout}
                setUpdatedCart={setUpdatedCart}
                UpdatedCart={UpdatedCart}
                setdeletestatus={setdeletestatus}
                setShowpayment={setShowpayment}
                showpayment={showpayment}
                ordertype={'pos_order'}
                setsearchproductstatus={setsearchproductstatus}
                searchproductstatus={searchproductstatus}
                parkid={state?.parkid}
                order_id={state?.order_id}
                order_edit={state?.order_edit}
                order_type={state?.order_type}
                service_labour_enable={state?.service_labour_enable}
              />
            ) : showcheckout === 'payment' ? (
              <CheckoutPayment
                UpdatedCart={UpdatedCart}
                setShowcheckout={setShowcheckout}
                order_id={state?.order_id}
                order_edit={state?.order_edit}
                order_type={state?.order_type}
                service_enable={state?.service_labour_enable}
              />
            ) : (
              <CheckoutBlank />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CollectionList;
